import React, { useState } from "react";
import { Image, Message, ImageProps, Button, Icon, Modal } from "semantic-ui-react";
import { useFileUploadService } from "../context/FileUploadServiceContext";
import useFileToken from "../hooks/useFileToken";
import { isLoaded, isLoadErrored } from "../../sg-core/models/ILoadable";
import * as Endpoint from "../../endpoints";

const PUBLIC_PATH = process.env.PUBLIC_URL


interface IImageProps extends ImageProps {
    id: string;
}

const getFileUrl = (baseUrl: string, fileId: string, token: string): string => {
    return [
        baseUrl,
        "?action=hae_tiedosto&varmenne=",
        token,
        "&tiedosto=",
        fileId,
    ].join("");
};

const ImageView: React.FC<IImageProps> = ({ id, ...imgProps }) => {
    const fileService = useFileUploadService();
    const [imageFailed] = useState(false)
    // const [preview, setPreview] = useState<TSubmittable<any>>(createUnsubmitted({}));

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);


    if (!fileService) {
        throw new Error("ImageView cannot exists without an SG fileupload context.");
    }

    const fileToken = useFileToken();
    if (imageFailed) {
        // eslint-disable-next-line 
        return (<a className={imgProps.className} style={{
            height: 90,
            width: 120,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.1)'
        }}>
            <Icon
                name="ban"
                size="large"
                color="grey"

            />
        </a>)
    }
    if (isLoaded(fileToken)) {
        const fileUrl = getFileUrl(
            Endpoint.Upload6.path,
            id,
            fileToken.data,
        );
        return (
            <Modal
                open={isModalOpen}
                trigger={(
                    <Image {...imgProps} src={fileUrl} />
                )}
                onOpen={openModal}
                onClose={closeModal}
            >
                <Modal.Content style={{
                    minHeight: "500px",
                    //  maxHeight: "600px",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden"
                }}>
                    <div>
                        <Image
                            src={fileUrl}
                            alt={id}

                            style={{
                                display: "block",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                width: "auto",
                                height: "auto",
                            }}
                        />
                    </div>
                </Modal.Content>
                <Modal.Actions >
                    <Button onClick={closeModal} negative style={{ width: "100%", marginLeft: 0 }}> Sulje </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    if (isLoadErrored(fileToken)) {
        return <Message negative compact>Kuvan lataus ei onnistunut</Message>;
    }

    return <Image {...imgProps} src={PUBLIC_PATH + "/loading_placeholder.gif"} />;

};

export default ImageView;
